import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/Service/api.service';
import { ExportService } from 'src/app/Service/export.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-bill-report',
  templateUrl: './bill-report.component.html',
  styleUrls: ['./bill-report.component.css']
})
export class BillReportComponent {

  constructor(
    public _apiService: ApiService,
    private notificationService: NzNotificationService,
    private datePipe: DatePipe,
    public cookie: CookieService,
    private _exportService: ExportService
  ) { }

  formTitle = 'Project Wise Yearly Billing';
  month: any = new Date();
  employeeData: any = [];
  maxColumns: any[] = []; //
  ngOnInit(): void {
    this.getMonthAndYear();
    this.initializeMaxColumns()
    this.yearChange(null);
  }

  startDate: any;
  endDate: any;
  selectyear: any;
  loadprojectexcel: boolean = false;

  yearChange(data: Date | null) {
    if (data) {
      this.selectyear = data.getFullYear();
      this.getAllEmployeeWiseHoursDetails(true);
    } else {
      this.selectyear = new Date().getFullYear();
      this.getAllEmployeeWiseHoursDetails(true);
    }
  }

  // Disable next year
  disabledDate = (current: Date): boolean => {
    // Disable dates beyond current year
    return current && current.getFullYear() > new Date().getFullYear();
  };

  private getMaxColumns(): number[] {
    // Ensure P array exists for all employees before checking length
    this.employeeData.forEach((employee) => {
      if (!employee.P) {
        employee.P = [];
      }
    });
    // Calculate max length of P arrays
    const maxLength = Math.max(
      ...this.employeeData.map((employee) => employee.P.length)
    );
    
    return Array.from({ length: maxLength }, (_, i) => i + 1);
  }

  dt = new Date();
  year: any = new Date();
  START_DATE: string;
  END_DATE: string;
  radioValue = 'E';

  getMonthAndYear() {
    this.month = new Date(this.dt.getFullYear(), this.dt.getMonth(), 1);
    this.year = new Date(this.dt.getFullYear(), 0, 1);
  }

  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  sortValue: string = 'desc';
  logtext: string = '';
  searchText: string = '';
  columns: string[][] = [['NAME', 'Name']];
  filterQuery: string = '';
  isProjectSpinning = false;
  loadingRecords = false;
  projectData = [];
  projectDataForExcel = [];
  date = new Date();
  // my code 
  initializeMaxColumns(): void {
    this.maxColumns = [
      { name: 'January', key: 'January' },
      { name: 'February', key: 'February' },
      { name: 'March', key: 'March' },
      { name: 'April', key: 'April' },
      { name: 'May', key: 'May' },
      { name: 'June', key: 'June' },
      { name: 'July', key: 'July' },
      { name: 'August', key: 'August' },
      { name: 'September', key: 'September' },
      { name: 'October', key: 'October' },
      { name: 'November', key: 'November' },
      { name: 'December', key: 'December' },
    ];
  }

  formatEmployeeData(data: any[]): any[] {
    return data.map((item) => {
      const formattedItem: any = {
        Project_Name: item.Project_Name.replace(/_/g, ' '), // Replaces underscores with spaces
        Total_Billing: item.Total_Billing,
        Invoice_Raised: item.Invoice_Raised,
        Received: item.Received,
        Pending: item.Pending,
      };

      this.maxColumns.forEach((month) => {
        formattedItem[`${month.key}_Billing`] = item[`${month.key}_Billing`] || 0;
        formattedItem[`${month.key}_Invoice`] = item[`${month.key}_Invoice`] || 0;
        formattedItem[`${month.key}_Received`] = item[`${month.key}_Received`] || 0;
        formattedItem[`${month.key}_Due`] = item[`${month.key}_Due`] || 0;
      });

      return formattedItem;
    });
  }

  calculateTotals(): any {
    const totals = {
      Project_Name: 'Total',
      Total_Billing: 0,
      Invoice_Raised: 0,
      Received: 0,
      Pending: 0,
    };

    this.maxColumns.forEach((month) => {
      totals[`${month.key}_Billing`] = 0;
      totals[`${month.key}_Invoice`] = 0;
      totals[`${month.key}_Received`] = 0;
      totals[`${month.key}_Due`] = 0;
    });

    this.employeeData.forEach((employee) => {
      totals.Total_Billing += employee.Total_Billing || 0;
      totals.Invoice_Raised += employee.Invoice_Raised || 0;
      totals.Received += employee.Received || 0;
      totals.Pending += employee.Pending || 0;

      this.maxColumns.forEach((month) => {
        totals[`${month.key}_Billing`] += employee[`${month.key}_Billing`] || 0;
        totals[`${month.key}_Invoice`] += employee[`${month.key}_Invoice`] || 0;
        totals[`${month.key}_Received`] += employee[`${month.key}_Received`] || 0;
        totals[`${month.key}_Due`] += employee[`${month.key}_Due`] || 0;
      });
    });

    return totals;
  }


  // getColumnTotal(column: string): number {
  //   return this.employeeData.reduce((sum, employee) => sum + (employee[column] || 0), 0);
  // }

  // getMonthlyTotal(month: string, type: string): number {
  //   return this.employeeData.reduce((sum, employee) => sum + (employee[`${month}_${type}`] || 0), 0);
  // }

  getColumnTotal(column: string): number {
    const total = this.employeeData.reduce((sum, employee) => sum + (employee[column] || 0), 0);
    return parseFloat(total.toFixed(2)); // Convert to fixed 2 decimals
  }
  
  getMonthlyTotal(month: string, type: string): number {
    const total = this.employeeData.reduce((sum, employee) => sum + (employee[`${month}_${type}`] || 0), 0);
    return parseFloat(total.toFixed(2)); // Convert to fixed 2 decimals
  }
  


  scroll = { x: '1600px', y: '400px' };
  months: any = [];

  getAllEmployeeWiseHoursDetails(reset: boolean = false) {
    var ok = true;
    if (ok) {
      if (reset) {
        this.pageIndex = 1;
      }
      this.loadingRecords = true;
      var sort: string;
      try {
        sort = this.sortValue.startsWith('a') ? 'asc' : 'desc';
      } catch (error) {
        sort = '';
      }
      if (this.searchText != '') {
        var likeQuery = ' AND';
        this.columns.forEach((column) => {
          likeQuery += ' ' + column[0] + " like '%" + this.searchText + "%' OR";
        });
        likeQuery = likeQuery.substring(0, likeQuery.length - 2);
      }
      // this.applyFilter();

      var filter = '';
      if (likeQuery) filter = this.filterQuery + likeQuery;
      else filter = this.filterQuery;

      this._apiService.EmployeeBilling(this.selectyear).subscribe(
        (data) => {
          this.loadingRecords = false;
          this.employeeData = data['results'].map(item => ({
            ...item,
            Project_Name: item.Project_Name.replace(/_/g, ' ') // Replace underscores with spaces
          }));



        
          // Extract and format months
          if (this.employeeData.length > 0) {
            const firstEmployee = this.employeeData[0];
            this.months = Object.keys(firstEmployee)
              .filter(key => key.endsWith('_Billing')) // Find keys that match the pattern for months
              .map(key => key.replace('_Billing', '')) // Remove '_Billing'
              .filter(month => month !== 'Total') // Remove 'Total' if it appears
          }
          const columnsPerMonth = 4; // 4 columns for each month: Billing, Invoice, Received, Due
          const fixedColumnWidth = 260 * 2; // Fixed width for non-dynamic columns (e.g., employee name, etc.)
          
          console.log(this.months);
          
          const columnWidthPerField = 95; // Average width for each column (adjust as needed)
          const dynamicColumnWidth = this.months.length * columnsPerMonth * columnWidthPerField; // Calculate dynamic width
          
          const scrollWidth = fixedColumnWidth + dynamicColumnWidth;
          
          this.scroll = { x: scrollWidth + 'px', y: '400px' }; // Set scroll configuration
          console.log(scrollWidth, 'Scroll Width');
          
          
          
        },
        (err) => {
          this.loadingRecords = false;
          if (err.status == 404) {
            this.notificationService.error('Server Not Found', '');
          } else {
            this.notificationService.error('An error occurred', '');
          }
        }
      );

    }
  }

  
  fireEvent() {
    
  
    // Prepare header rows based on `months`
    const headerRow1 = [
      'Project Name',
      'Invoice Raised',
      'Received',
      'Pending',
      ...this.months.flatMap((month) => [`${month}`, `${month}`, `${month}`, `${month}`]),
      'Total Billing'
    ];
  
    const headerRow2 = [
      '',
      '',
      '',
      '',
      ...this.months.flatMap(() => ['Billing', 'Invoice', 'Received', 'Due']),
      ''
    ];
  
    // Prepare data rows
    let totalBilling = 0;
    let totalInvoice = 0;
    let totalReceived = 0;
    let totalPending = 0;
    const monthlyTotals :any = this.months.map(() => ({ Billing: 0, Invoice: 0, Received: 0, Due: 0 }));
  
    const employeeRows = this.employeeData.map((employee) => {
      const row = [
        employee.Project_Name,
        parseFloat(employee.Invoice_Raised).toFixed(2) || 0,
        parseFloat(employee.Received).toFixed(2) || 0,
        parseFloat(employee.Pending).toFixed(2) || 0,
        ...this.months.flatMap((month, index) => {
          const billing = employee[`${month}_Billing`] || 0;
          const invoice = employee[`${month}_Invoice`] || 0;
          const received = employee[`${month}_Received`] || 0;
          const due = employee[`${month}_Due`] || 0;
  
          // Accumulate monthly totals
          monthlyTotals[index].Billing += billing;
          monthlyTotals[index].Invoice += invoice;
          monthlyTotals[index].Received += received;
          monthlyTotals[index].Due += due;
  
          return [
            billing.toFixed(2),  // Format billing amount
            invoice.toFixed(2),  // Format invoice amount
            received.toFixed(2), // Format received amount
            due.toFixed(2)       // Format due amount
          ];        }),
        employee.Total_Billing || 0
      ];
  
      totalBilling += employee.Total_Billing || 0;
      totalInvoice += employee.Invoice_Raised || 0;
      totalReceived += employee.Received || 0;
      totalPending += employee.Pending || 0;
  
      return row;
    });
  
    // Add the "Total" row with aggregated data
    const totalRow = [
      'Total',
      totalInvoice,
      totalReceived,
      totalPending,
      ...monthlyTotals.flatMap((total) => [
        total.Billing,
        total.Invoice,
        total.Received,
        total.Due
      ]),
      totalBilling
    ];
  
    console.log(totalRow , 'Total Row');
    
    // Combine headers and data into one array for Excel export
    const worksheetData = [headerRow1, headerRow2, ...employeeRows, totalRow];
  
    // Create a worksheet
    const ws = XLSX.utils.aoa_to_sheet(worksheetData);
  
    // Merge cells for the main header
    this.months.forEach((_, index) => {
      ws['!merges'] = ws['!merges'] || [];
      ws['!merges'].push({
        s: { r: 0, c: 4 + index * 4 },
        e: { r: 0, c: 7 + index * 4 }
      });
    });
  
    // Define column widths
    ws['!cols'] = [
      { wch: 20 }, // Project Name
      { wch: 15 }, // Invoice Raised
      { wch: 15 }, // Received
      { wch: 15 }, // Pending
      ...this.months.flatMap(() => [{ wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }]), // Monthly columns
      { wch: 15 } // Total Billing
    ];
  
    // Apply styles for headers
    const headerCellStyle = {
      font: { bold: true, color: { rgb: 'FFFFFF' } },
      fill: { fgColor: { rgb: '4F81BD' } },
      alignment: { horizontal: 'center', vertical: 'center' }
    };
  
    // Apply styles to both header rows
    [headerRow1, headerRow2].forEach((headerRow, rowIndex) => {
      headerRow.forEach((_, colIndex) => {
        const cellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
        ws[cellAddress] = ws[cellAddress] || { t: 's', v: headerRow[colIndex] };
        ws[cellAddress].s = headerCellStyle;
      });
    });
  
    // Create a workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Employee Data');
  
    // Save to file
    XLSX.writeFile(wb, 'Project Wise Yearly Billing.xlsx');
  }
}
